export default "__VITE_ASSET__DtpeTlw6__"